import DataSource from "../DataSource/DataSource";

export default class OTEService {

  constructor(server){
    this.server = server;
  }

  requestPOF(requests){
    return this.server("ote.pof.request", {requests: requests});
  }

  requestDUFVO(requests){
    return this.server("ote.duf.vo.request", {requests: requests});
  }

  getPOFSource(){
    return new DataSource(this.server, "ote.pof.source", {limit: 20});
  }

  getInvoiceData(pofIds){
    window.open(this.server.getRequestUrl("ote.pof.invoice", {pofIds: pofIds}));
  }

  deletePOF(id){
    return this.server("ote.pof.delete", {id: id});
  }


}


// WEBPACK FOOTER //
// ./src/OTE/OTEService.js